import React from "react";
import { Switch } from "react-router-dom";
import NotFound from "../General/NotFound";
import { Route, useLocation } from "react-router-dom";
const CIAMWrapper = () => {
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <Switch>
        <Route exact path={"/ciam/oauth_callback"} component={CIAM} />
        <Route component={NotFound} />
      </Switch>
    </div>
  );
};
const CIAM = () => {
  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params["code"]) {
      window.location.href = `https://support.westkowloon.hk/donation/auth/user/landing?code=${params["code"]}`;
    }
  }, []);
  return <p>Login success, The window will be closed automatically.</p>;
};
export default CIAMWrapper;
